import React, { useCallback, useEffect, type FC } from "react";

import type { TrackLocation } from "@/hooks/use-segment";

type SwitchOrgModalProps = {
    onClose: () => void;
    onConfirm: () => void;
    "data-track-location": TrackLocation;
};

/**
 * Auto-confirms org switch immediately. Kept as a component to preserve
 * the call-site interface while the modal shell is removed.
 */
export const SwitchOrgModal: FC<SwitchOrgModalProps> = ({ onConfirm }) => {
    const confirmed = React.useRef(false);
    const confirm = useCallback(() => {
        if (confirmed.current) {
            return;
        }
        confirmed.current = true;
        onConfirm();
    }, [onConfirm]);

    useEffect(() => {
        confirm();
    }, [confirm]);

    return null;
};
